import { CircularProgress } from '@mui/material';
import { FunctionComponent } from 'react';

import { LoaderProps } from './Loader.types';

const Loader: FunctionComponent<LoaderProps> = (
  props: LoaderProps
): JSX.Element => <CircularProgress {...props} />;

Loader.defaultProps = {
  size: '9.2rem',
};

export default Loader;
